import md5 from 'js-md5';
import { API_HOST } from 'boot/axios';

// eslint-disable-next-line import/prefer-default-export

export function isFlowVisible (flowNum, flows, hashtags = '', ignoreHashtags = false) {
    if (!flows) {
        return true;
    }
    flowNum = +flowNum;

    let tags;
    const j = flows.indexOf('#');
    if (j >= 0) {
        tags = flows.slice(j, flows.length);
        flows = flows.slice(0, j);
    }
    let okFlow = false;
    let okHashtag = false;
    if (flows) {
        const flowParts = flows.split(',').map((i) => i.trim());
        for (let k = 0; k < flowParts.length; k += 1) {
            const flowPart = flowParts[k];
            if (window.intervals.has(flowPart)) {
                // значит интервал
                const interval = window.intervals.split(flowPart).map((i) => +i.trim());
                if (interval.length === 2) {
                    const start = +(interval[0] || 1);
                    const end = +(interval[1] || 99999999);
                    okFlow = (flowNum >= start && flowNum <= end);
                }
            } else if (flowPart) {
                const arr = flowPart.split(',').map((i) => +i.trim());
                okFlow = (arr.includes(flowNum));
            }
            if (okFlow) {
                break;
            }
        }
    } else {
        okFlow = true;
    }
    /*
    if (flows) {
        if (window.intervals.has(flows)) {
            // значит интервал
            const interval = window.intervals.split(flows).map((i) => +i.trim());
            if (interval.length === 2) {
                const start = +(interval[0] || 1);
                const end = +(interval[1] || 99999999);
                okFlow = (flowNum >= start && flowNum <= end);
            }
        } else {
            flows = flows.trim();
            if (flows) {
                const arr = flows.split(',').map((i) => +i.trim());
                okFlow = (arr.includes(flowNum));
            }
        }
    } else {
        okFlow = true;
    }
    */

    if (tags && !ignoreHashtags) {
        // проверить пересечения тегов hashtags и tags
        const tagsArray = tags.split('#').map((i) => i.trim());
        const userTagsArray = (hashtags || '').split('#').map((i) => i.trim());
        const intersection = tagsArray.filter(x => userTagsArray.includes(x)).filter(y => y);
        okHashtag = intersection.length > 0;
    } else {
        okHashtag = Boolean(!hashtags) || Boolean(!tags);
    }

    return okFlow && okHashtag;
}

export function isVisibleByHashtags (userTags, checkTags) {
    if (!userTags) {
        return false;
    }
    if (!checkTags) {
        return false;
    }
    const tagsArray = checkTags.split('#').map((i) => i.trim());
    const userTagsArray = userTags.split('#').map((i) => i.trim());
    const intersection = tagsArray.filter(x => userTagsArray.includes(x)).filter(y => y);
    return intersection.length > 0;
}

export function inArrayString (arrayString, what, delimiter = ',') {
    if (!what) {
        return false;
    }
    const arr = arrayString.split(delimiter).map((i) => i.trim());
    return arr.includes(what.trim());
}

export function copyToClipboard (text) {
    navigator.clipboard.writeText(text)
        .then(() => {
        })
        .catch(() => {
            const input = document.createElement('textarea');
            input.innerHTML = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        });
}

export function stripHtmlTags (text) {
    if (!text) { return ''; }
    let result = text?.replace(/<[^>]*>/g, '');
    result = result.replaceAll('&nbsp;', ' ');
    return result;
}

export function getRandomInt (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getRandomFromArray (arr) {
    const i = getRandomInt(0, arr.length - 1);
    return arr[i];
}

export function isValidInterval (s) {
    if (!s) {
        return false;
    }
    if (Number.isFinite(s)) {
        return true;
    }
    const checkInterval = (val) => {
        const interval = window.intervals.split(val).map((i) => +i.trim());
        if (interval.length === 2 && !Number.isNaN(interval[0]) && !Number.isNaN(interval[1])) {
            const start = +(interval[0] || 1);
            const end = +(interval[1] || 99999999);
            return !Number.isNaN(start) && !Number.isNaN(end);
        }
        return false;
    };
    s = s.trim();
    let okFlow = false;
    if (!s.includes(',') && !window.intervals.has(s)) {
        // Убрал условие и изменил проверку на isNull для дробных потоков
        // if (s.includes('.')) {
        //     return false;
        // }
        okFlow = !Number.isNaN(+s);
    }
    if (s.includes(',')) {
        const arr = s.split(',').map((i) => i.trim());
        okFlow = true;
        for (let i = 0; i < arr.length; i += 1) {
            const val = arr[i];
            if (window.intervals.has(val)) {
                // значит интервал
                okFlow = checkInterval(val);
                if (!okFlow) {
                    break;
                }
            } else if (Number.isNaN(+arr[i])) {
                okFlow = false;
                break;
            }
        }
    }
    if (window.intervals.has(s) && !s.includes(',')) {
        // значит интервал
        okFlow = checkInterval(s);
    }
    return okFlow;
}

export function normalizeOkatoCode (okato, okatos) {
    if (!okato) {
        return undefined;
    }
    if (!okatos) {
        return undefined;
    }
    /*
    if (!okatos) {
        await queryBot('select code, label from okato').then((r) => {
            okatos = [].concat(r.data);
        });
    }
    */

    let result;

    const first3 = +okato.slice(0, 3);
    const first4 = +okato.slice(0, 4);
    if (first4 >= 7114 && first4 <= 7117) {
        result = '71140000000';
    } else if (first3 === 711) {
        result = '71100000000';
    } else if (first3 === 111) {
        result = '11100000000';
    } else {
        const clientOkato = okato.slice(0, 2);
        const [ok] = okatos.filter((o) => o.code.startsWith(clientOkato));
        if (ok) {
            result = ok.code;
        }
    }
    return result;
}

export function getUserAgentUnique () {
    const deviceId = navigator.userAgent;
    const { buildID } = navigator;
    const pluginsText = JSON.stringify(navigator.plugins);
    const text = `${deviceId}-${pluginsText}-${window.screen.width}-${window.screen.height}-${buildID}`;
    return md5(text);
}

export function shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function getUserLKKey (chatId) {
    const key = md5(`${chatId}`).substring(0, 12);
    return key;
}

export function getUserLKUrl (chatId) {
    const key = md5(`${chatId}`).substring(0, 12);
    const url = `${API_HOST}/user?key=${key}`;
    return url;
}

export function isValidFio (text) {
    if (!text) {
        return false;
    }
    const allow = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890ёйцукенгшщзхъфывапролджэячсмитьбюЁЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ ';
    for (let i = 0; i < text.length; i += 1) {
        if (!allow.includes(text[i])) {
            return false;
        }
    }
    return true;
}

export function waitFor (ms = 500) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, ms);
    });
}

export function downloadUrl2 (url, name = undefined) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', name || url.split('/').pop());
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl); // Освобождаем память
        })
        .catch(err => console.error('Ошибка при скачивании файла:', err));
}

export function downloadUrl (url, name = undefined) {
    if ((url || '').split('.').pop() === 'webp') {
        downloadUrl2(url, name);
        return;
    }
    const link = document.createElement('a');
    link.setAttribute('href', url);
    // Используем имя файла из URL, если name не передан
    link.setAttribute('download', name || url.split('/').pop());
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function clearHTMLTags (text) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = text;
    const elements = tmp.getElementsByTagName('*');
    _.each(elements, e => { if (e) e.innerHTML += ' '; });
    let s1 = tmp.textContent || tmp.innerText || '';
    s1 = s1.replace(/(?:\r\n|\r|\n)/g, ' ');
    s1 = s1.trim();
    return s1;
}
